import React, { createContext, useContext, useState, useCallback } from "react";

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback((content, title = "") => {
    setModalContent(content);
    setModalTitle(title);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setModalContent(null);
    setModalTitle("");
  }, []);

  return (
    <ModalContext.Provider value={{ isOpen, modalContent, modalTitle, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);